export default "__VITE_ASSET__Crw81oZ9__"